<template>
  <div>
    <slot v-if="passthrough" />
    <ap3-access-dialog v-else-if="blocked" :site="site" :access="access" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ap3AccessDialog from '@/components/ap3AccessDialog';

export default {
  components: { ap3AccessDialog },
  data: () => ({
    loadFailed: false,
  }),
  computed: {
    ...mapGetters('splitio', ['isFeatureOn']),
    ...mapGetters('sites', ['ap3Access']),
    ...mapState('sites', ['siteMap']),
    siteId() {
      return this.$route.params.site_id;
    },
    site() {
      return this.siteMap[this.siteId];
    },
    access() {
      return this.ap3Access(this.siteId);
    },
    // routes without a site have nothing to gate on, and the flag lets us drop the
    // gate without a deploy
    gateOn() {
      return !!this.siteId && this.isFeatureOn('AP3-ACCESS-GATE');
    },
    // if the site cannot be read we let people through rather than stranding them
    passthrough() {
      if (!this.gateOn || this.loadFailed) return true;
      return !!this.site && this.access === 'allowed';
    },
    blocked() {
      return this.gateOn && !this.loadFailed && !!this.site && this.access !== 'allowed';
    },
  },
  watch: {
    siteId: {
      handler: 'loadSite',
      immediate: true,
    },
    gateOn: 'loadSite',
  },
  methods: {
    ...mapActions('sites', ['getLocationGroup']),
    async loadSite() {
      this.loadFailed = false;
      if (!this.gateOn || this.site) return;
      try {
        await this.getLocationGroup({ id: this.siteId });
      } catch (err) {
        console.error('ap3 access check could not load site', err);
        this.loadFailed = true;
      }
    },
  },
};
</script>
